import {parseResponse} from "../api"

export default class InvoiceService {
  constructor(axios) {
    // todo(egor): add config for domain
    this.axios = axios
  }

  async getMetadata({table, id}) {
    if (!table) {
      throw Error("Can't be empty `table`")
    }

    if (!id) {
      throw Error("`invoiceId` must be id")
    }

    return this.axios.post('/api/metadata/get', {
      table: _.toString(table),
      id: _.toString(id),
    }).then((response) => {
      return parseResponse(response)
    })
  }

  async updateMetadata({table, id, delta}) {
    if (!table) {
      throw Error("Can't be empty `table`")
    }

    if (!id) {
      throw Error("`invoiceId` must be id")
    }

    if (!_.isObject(delta)) {
      throw Error("`delta` must be objectt")
    }

    return this.axios.post('/api/metadata/update', {
      table: _.toString(table),
      id: _.toString(id),
      delta: delta,
    }).then((response) => {
      return parseResponse(response)
    })
  }
}




// WEBPACK FOOTER //
// ./src/services/MetadataService.js